import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-be088eea")

_pushScopeId("data-v-be088eea")
const _hoisted_1 = { class: "reservation_calendar genericPadding hasHeader" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_12 greyBlue text-uppercase" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "twoBlocksContainer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_community_card = _resolveComponent("community-card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_3
      ]),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$filters.date(_ctx.selectedDay)), 1),
      _hoisted_5
    ]),
    (_ctx.events.length == 0)
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 0,
          localizedKey: "app_nessuneventotrovato",
          text: "Nessun evento trovato",
          class: "fs_14 grey d-block text-center mt-3"
        }))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.events, (item, ii) => {
            return (_openBlock(), _createBlock("div", {
              class: "block mr-3 mt-3",
              key: ii
            }, [
              _createVNode(_component_community_card, {
                item: item,
                onClick: ($event: any) => (_ctx.openEvent(item))
              }, null, 8, ["item", "onClick"])
            ]))
          }), 128))
        ]))
  ]))
})